/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Companydetails_Businesslabel2Inputs */

const ja_company_companydetails_businesslabel2 = /** @type {(inputs: Company_Companydetails_Businesslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事業内容`)
};

const en_company_companydetails_businesslabel2 = /** @type {(inputs: Company_Companydetails_Businesslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business`)
};

/**
* | output |
* | --- |
* | "Business" |
*
* @param {Company_Companydetails_Businesslabel2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const company_companydetails_businesslabel2 = /** @type {((inputs?: Company_Companydetails_Businesslabel2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Companydetails_Businesslabel2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_company_companydetails_businesslabel2(inputs)
	return en_company_companydetails_businesslabel2(inputs)
});
export { company_companydetails_businesslabel2 as "company_companyDetails_businessLabel" }